<template>
  <v-container class="container-card">
    <v-card>
      <Permissoes />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Permissoes from "@/components/sistema/permissoes/Permissoes";
export default {
  name: "ConsultaPermissoes",

  components: {
    Permissoes
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Permissões");
  }
};
</script>
